import React from 'react';
import { Controller } from 'react-hook-form';

export const FormCheckBox = ({ control, name, id, label, rules, ...props }) => {
  return (
    <>
      <Controller
        name={name}
        control={control}
        rules={rules}
        render={({ field, fieldState }) => (
          <div className="checkbox c-checkbox">
            <label>
              <input
                type="checkbox"
                id={id}
                {...field}
                {...props}
                checked={field.value}
                onChange={(e) => field.onChange(e.target.checked)}
              />
              <span className="fa fa-check"></span> <b>{label}</b>
            </label>
            {fieldState.invalid && <div className="text-danger">{fieldState.error?.message}</div>}
          </div>
        )}
      />
    </>
  );
};

export default FormCheckBox;
